import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray, inherits as _inherits, createSuper as _createSuper, createClass as _createClass, classCallCheck as _classCallCheck } from './_virtual/_rollupPluginBabelHelpers.mjs';
import { isDifferentArray } from '@toss/utils';
import { forwardRef, useContext, useRef, useImperativeHandle, useState, Component } from 'react';
import { ErrorBoundaryGroupContext } from './ErrorBoundaryGroup.mjs';
import { jsx } from 'react/jsx-runtime';

var initialState = {
  error: null
};

var BaseErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(BaseErrorBoundary, _Component);

  var _super = _createSuper(BaseErrorBoundary);

  function BaseErrorBoundary() {
    var _this;

    _classCallCheck(this, BaseErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = initialState;
    _this.updatedWithError = false;

    _this.resetErrorBoundary = function () {
      var _this$props$onReset, _this$props;

      (_this$props$onReset = (_this$props = _this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props);

      _this.resetState();
    };

    return _this;
  }

  _createClass(BaseErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var _this$props2 = this.props,
          onError = _this$props2.onError,
          ignoreError = _this$props2.ignoreError;

      if (ignoreError !== null && ignoreError !== void 0 && ignoreError(error)) {
        throw error;
      }

      onError === null || onError === void 0 ? void 0 : onError(error, info);
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.updatedWithError = false;
      this.setState(initialState);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var error = this.state.error;

      if (error == null) {
        return;
      }

      var resetKeys = this.props.resetKeys;

      if (!this.updatedWithError) {
        this.updatedWithError = true;
        return;
      }

      if (isDifferentArray(prevProps.resetKeys, resetKeys)) {
        this.resetErrorBoundary();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          renderFallback = _this$props3.renderFallback;
      var error = this.state.error;

      if (error != null) {
        return renderFallback({
          error: error,
          reset: this.resetErrorBoundary
        });
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        error: error
      };
    }
  }]);

  return BaseErrorBoundary;
}(Component);

var ErrorBoundary = /*#__PURE__*/forwardRef(function (props, resetRef) {
  var _useContext;

  var group = (_useContext = useContext(ErrorBoundaryGroupContext)) !== null && _useContext !== void 0 ? _useContext : {
    resetKey: 0
  };
  var resetKeys = [group.resetKey].concat(_toConsumableArray(props.resetKeys || []));
  var ref = useRef(null);
  useImperativeHandle(resetRef, function () {
    return {
      reset: function reset() {
        var _ref$current;

        return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.resetErrorBoundary();
      }
    };
  });
  return /*#__PURE__*/jsx(BaseErrorBoundary, _objectSpread2(_objectSpread2({}, props), {}, {
    resetKeys: resetKeys,
    ref: ref
  }));
});

if (process.env.NODE_ENV !== 'production') {
  ErrorBoundary.displayName = 'ErrorBoundary';
}

var useErrorBoundary = function useErrorBoundary() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  if (error != null) {
    throw error;
  }

  return setError;
};
var withErrorBoundary = function withErrorBoundary(Component, errorBoundaryProps) {
  var Wrapped = function Wrapped(props) {
    return /*#__PURE__*/jsx(ErrorBoundary, _objectSpread2(_objectSpread2({}, errorBoundaryProps), {}, {
      children: /*#__PURE__*/jsx(Component, _objectSpread2({}, props))
    }));
  };

  if (process.env.NODE_ENV !== 'production') {
    var name = Component.displayName || Component.name || 'Component';
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
  }

  return Wrapped;
};

export { ErrorBoundary, useErrorBoundary, withErrorBoundary };
